import React from "react";
import {useSelector} from "react-redux";
import SingleSelectField from "../../../../components/fields/select/SingleSelectField";
import {t} from "../../../../store/localization/TranslMessasge";
import {IApplicationState} from "../../../../store/Store";
import {ErrorTranslationKey} from "../ErrorTranslationKey";
import Snackbar from "../snackbar/Snackbar";

interface EditableViewpointComponentProps {
    id: string;
    label: string;
    viewpoint: string;
    doUpdate: (value: string) => Promise<any>;
    onSuccessfulUpdate: (value: string) => void;
    readonly?: boolean;
}

export default function EditableViewpointComponent(props: Readonly<EditableViewpointComponentProps>) {

    const {id, label, viewpoint} = props;
    const {doUpdate, onSuccessfulUpdate} = props;

    function updateViewpoint(value: string | null) {
        doUpdate(value ?? '')
                .then(() => onSuccessfulUpdate(value ?? ''))
                .catch((error) => Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error));
    }

    const viewpoints = useSelector((state: IApplicationState) => state.pages.common.options.viewpoints.resource);
    const options = viewpoints.map((viewpoint) => viewpoint.identifier);
    const optionLabelMap = new Map(viewpoints.map((viewpoint) => ([viewpoint.identifier, viewpoint.name])));

    return (
            <SingleSelectField
                    id={id}
                    label={label}
                    value={viewpoint}
                    onChange={updateViewpoint}
                    options={options}
                    getOptionLabel={(option) => optionLabelMap.get(option) ?? option}
                    acceptFreeText={true}
                    required={false}
                    readOnly={props.readonly}/>
    );
}
